import Vue from 'vue'
import Router from 'vue-router'
import Demo from '@/views/demo/index.vue';
import loginRegRouterMap from './modules/login-reg';
import mainRouterMap from './modules/main';
import indexRouterMap from './modules/index';
import systemRouterMap from './modules/system';
import newManagementRouterMap from './modules/new-management';
import routerFormatter from './routerFormatter';
import userManagementRouterMap from './modules/user-management';
import platformRouterMap from './modules/platform';
import customerServiceRouterMap from './modules/customer-service';
import aboutJcnRouterMap from './modules/about-jcn';
import contactRouterMap from './modules/contact';
import slideRouterMap from './modules/slide';
import productRouterMap from './modules/product';
import businessRouterMap from './modules/business';
import videoAreaRouterMap from './modules/video-area';
import solutionRouterMap from './modules/solution';
import solutionFtRouterMap from './modules/solution-ft';
import downloadRouterMap from './modules/download';
Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/demo', component: Demo },
    {
      path: '/main',
      component: mainRouterMap.main,
      children: [
        { path: '/', redirect: 'index' },
        { path: 'stayTuned', component: mainRouterMap.stayTuned },
        ...routerFormatter(indexRouterMap), //首页
        ...routerFormatter(systemRouterMap), //系统管理
        ...routerFormatter(newManagementRouterMap), //农技资讯
        ...routerFormatter(userManagementRouterMap), //用户管理,
        ...routerFormatter(platformRouterMap), //网站设置
        ...routerFormatter(customerServiceRouterMap), //客户服务
        ...routerFormatter(aboutJcnRouterMap), //走进JNC
        ...routerFormatter(contactRouterMap), //联系我们
        ...routerFormatter(slideRouterMap), //幻灯片
        ...routerFormatter(productRouterMap), //产品管理
        ...routerFormatter(videoAreaRouterMap), //视频管理
        ...routerFormatter(businessRouterMap), //视频管理
        ...routerFormatter(solutionRouterMap), //解决方案
        ...routerFormatter(solutionFtRouterMap), //粉体解决方案
        ...routerFormatter(downloadRouterMap), //粉体解决方案
        { path: '*', component: mainRouterMap.stayTuned } //没有匹配到
      ]
    },
    { path: '/login', component: loginRegRouterMap.login },
    { path: '/register', component: loginRegRouterMap.register },
    { path: '/details', component: newManagementRouterMap.details }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js